<template>
	<div class="icon-double-chevron">
		<svg
			width="16.000000"
			height="16.000000"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
		>
			<desc>Created with Pixso.</desc>
			<defs>
				<clipPath id="clip103_1324">
					<rect
						id="Icon / Pagination / First"
						width="16.000000"
						height="16.000000"
						fill="white"
						fill-opacity="0"
					/>
				</clipPath>
			</defs>
			<rect
				id="Icon / Pagination / First"
				width="16.000000"
				height="16.000000"
				fill="#FFFFFF"
				fill-opacity="0"
			/>
			<g clip-path="url(#clip103_1324)">
				<path
					id="Vector"
					d="M11.72 12L12.66 11.06L9.61 8L12.66 4.93L11.72 4L7.72 8L11.72 12Z"
					fill="#333333"
					fill-opacity="1.000000"
					fill-rule="nonzero"
				/>
				<path
					id="Vector"
					d="M7.33 12L8.27 11.06L5.22 8L8.27 4.93L7.33 4L3.33 8L7.33 12Z"
					fill="#333333"
					fill-opacity="1.000000"
					fill-rule="nonzero"
				/>
			</g>
		</svg>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({})
export default class IconDoubleChevron extends Vue {}
</script>

<style scoped lang="scss">
.icon-double-chevron {
	display: flex;
}
</style>
